/* global scheduler */
export function createSubjects() {
  return {
    namespaced: true,
    state: {
      subjects: [],

      subjectById: {}
    },
    actions: {
      refresh: async ({commit}, subjects) => {
        commit('replaceSubjects', subjects)

        const subjectById = {}
        for (const subject of subjects) {
          subjectById[subject.id] = subject
          await scheduler.yield()
        }
        commit('replaceSubjectById', subjectById)
      }
    },
    mutations: {
      replaceSubjects: (state, value) => {
        state.subjects = value
      },
      replaceSubjectById: (state, value) => {
        state.subjectById = value
      }
    }
  }
}
